<template>
    <div>
        <InterfaceName :interfaceName="interfaceName" />
        <InterfaceSpe :requestUrl="requestUrl" :requestMethod="requestMethod" />
        <InputParam :inputTableData="inputTableData" />
        <div class="tip">{{ tipText }}</div>
        <ReturnParam :returnObj="returnObj" />
    </div>
</template>

<script>
import InterfaceName from "../Acomponents/InterfaceName.vue";
import InterfaceSpe from "../Acomponents/InterfaceSpe.vue";
import InputParam from "../Acomponents/InputParam.vue";
import ReturnParam from "../Acomponents/ReturnParam.vue";

export default {
    components: { InterfaceName, InterfaceSpe, InputParam, ReturnParam },
    data() {
        return {
            interfaceName: "获取询盘列表",
            requestUrl: "https://crm.qixinerp.com/open/Inquiry/List",
            requestMethod: "POST",
            inputTableData: [],
            returnObj: {},
            tipText: "*tip：如果startDate和endDate都为空，第一次查询截至当前时间的所有询盘，第二次查询第一次查询时间之后的所有询盘。如果startDate和endDate都不为空，则查询这两个日期之间的所有询盘。",
        };
    },
    methods: {},
    mounted() {
        this.inputTableData = [
            {paramName: "startDate", valueType: "string", explain: "开始日期", required: false},
            {paramName: "endDate", valueType: "string", explain: "结束日期", required: false},
        ];
        this.returnObj = {
            isSuccess: true,
            errorMessage: null,
            data: [
                {
                    "key": "e81d343ac88045048efbcf790ca49de3",
                    "company": "测试公司1",
                    "name": "pxx1",
                    "phone": "2749878",
                    "email": "111@qq.com",
                    "country": "中国",
                    "countryStd": "",    
                    "json": "",
                    "phase": "潜在",
                    "platform": "建站",
                    "createdTime": "2026-04-15 17:26:34",
                },
                {
                    "key": "e81d343ac88045048efbcf790ca49de4",
                    "company": "测试公司2",
                    "name": "pxx2",
                    "phone": "2749878",
                    "email": "222@qq.com",
                    "country": "中国",
                    "countryStd": "",    
                    "json": "",
                    "phase": "潜在",
                    "platform": "建站",
                    "createdTime": "2026-04-15 17:26:34",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.tip{
    color: #6a6a6a;
    font-size: 14px;
    margin-top: 10px;
    line-height: 20px;
}
</style>